import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { WithTheme } from './../../../setup/index'
import { transition } from './../../../common/Mixins'
import media from '../../../common/MediaQueries'
import { PaginationStyleProps } from './types'

const PaginationStyled = styled.div`
  display: flex;
  align-items: center;

  @media ${media.maxPhone} {
    width: 100%;
    justify-content: space-between;
  }
`

const PaginationNavStyled = styled.div<WithTheme<PaginationStyleProps>>`
  display: flex;
  margin-bottom: 0.9375rem;
  cursor: pointer;
  ${({ isInactive, theme }) =>
    isInactive &&
    css`
      color: ${theme.colors.gray5};
      pointer-events: none;
    `};
`

const PaginationListStyled = styled.ul`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 0 0.625rem;
`

const PaginationListItemStyled = styled.li<WithTheme>`
  ${transition}
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 0.3125rem;
  background-color: #fff;
  cursor: pointer;
  border: 0.0625rem solid ${({ theme }) => theme.colors.white};

  width: 1.5rem;
  height: 1.5rem;

  margin: 0 7px 14px;

  &:hover {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.green};
    border-color: ${({ theme }) => theme.colors.gray5};
  }

  /* &:not(:last-child) {
    ${({ theme }) => (theme.direction === 'rtl' ? ' margin-left: 0.9375rem;' : 'margin-right: 15px;')}
  } */

  ${({ isActive, theme }) =>
    isActive &&
    css`
      color: ${theme.colors.white};
      background-color: ${theme.colors.green};
      border-color: ${theme.colors.gray5};
    `};
`

const PaginationListItemLinkStyled = styled.span<WithTheme>`
  display: block;
  width: 100%;
  height: 100%;
  font-size: 0.75rem;
  padding: 0.3125rem;
  text-align: center;
  line-height: 1;
`

export { PaginationStyled, PaginationNavStyled, PaginationListStyled, PaginationListItemStyled, PaginationListItemLinkStyled }
